import React, { useState } from 'react';
import ThemeToggle from '../ThemeToggle';
import { GameState } from '../../types';
import { PANEL_STYLES, BUTTON_DANGER, BUTTON_SIZES } from '../../constants/styles';

interface GameHeaderProps {
  gameState: GameState;
  onLeave: () => void;
}

const GameHeader: React.FC<GameHeaderProps> = ({ gameState, onLeave }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyRoomCode = async () => {
    try {
      // Copy the full URL with the room code as fragment
      const url = `${window.location.origin}${window.location.pathname}#${gameState.id}`;
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy URL:', err);
    }
  };

  return (
    <div className={`${PANEL_STYLES} mb-2`}>
      <div className="flex justify-between items-center">
        <div className="flex-1">
          <h1 className="text-sm font-bold text-gray-900 dark:text-white">Liar's Dice</h1>
          <button
            onClick={handleCopyRoomCode}
            className="text-xs text-gray-600 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 cursor-pointer transition-colors flex items-center gap-1 group"
            title="Click to copy game URL"
          >
            <span>Room: <span className="font-semibold">{gameState.id}</span></span>
            <span className="text-[10px] opacity-0 group-hover:opacity-100 transition-opacity">
              {copied ? '✓ Copied!' : '📋'}
            </span>
          </button>
          <p className="text-xs text-gray-600 dark:text-gray-400">
            R{gameState.round} · {gameState.phase}
          </p>
        </div>
        <div className="flex gap-2">
          <ThemeToggle />
          <button
            onClick={onLeave}
            className={`${BUTTON_DANGER} ${BUTTON_SIZES.xs}`}
          >
            Leave
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameHeader;